import * as React from "react";
import { BaseIcon, BaseIconProps } from "@/components/icons/primitives/BaseIcon";

/**
 * Telegram logo icon - simple logo mark without background
 * Use this for custom styling with your own underlay
 *
 * @example
 * ```tsx
 * // With default underlay
 * <TelegramIcon size="md" withUnderlay />
 *
 * // With custom underlay
 * <TelegramIcon
 *   size="md"
 *   withUnderlay
 *   underlayClassName="size-10 bg-custom"
 * />
 * ```
 */
export const TelegramIcon = React.forwardRef<SVGSVGElement, Omit<BaseIconProps, "children">>((props, ref) => {
  return (
    <BaseIcon ref={ref} aria-label="Telegram" viewBox="0 0 23 16" {...props}>
      <path
        d="M19.5658 0.859C19.6904 0.0535 18.9246 -0.582 18.2084 -0.268L0.578818 7.3448C0.0652285 7.5703 0.102799 8.3483 0.635468 8.5179L3.94508 9.52465C4.53685 9.7105 5.17907 9.62 5.69765 9.28215L13.0342 4.6203C13.2342 4.4821 13.4522 4.7665 13.2813 4.9426L7.86011 10.8646C7.3642 11.3781 7.46903 12.2461 8.07203 12.6005L14.3782 16.8523C15.0377 17.2442 15.8809 16.8346 15.993 16.0761L19.5658 0.859Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
});

TelegramIcon.displayName = "TelegramIcon";
